import { Controller } from "@hotwired/stimulus";
import Swiper from "swiper";
import { Pagination, Autoplay } from "swiper/modules";

export default class extends Controller {
  connect() {
    const swiperContainer2 = this.element.querySelector(".mySwiper2");
    if (swiperContainer2) {
      console.log("Initializing mySwiper2");
      this.swiper2 = new Swiper(swiperContainer2, {
        modules: [Pagination, Autoplay],
        slidesPerView: 1,
        spaceBetween: 0,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
        },
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        grabCursor: true,
        touchRatio: 1,
        simulateTouch: true,
      });
    }

    const swiperContainer = this.element.querySelector(".mySwiper");
    if (swiperContainer) {
      this.swiper = new Swiper(swiperContainer, {
        slidesPerView: 1,
        spaceBetween: 0,
      });

      const btnNext = this.element.querySelectorAll("#btn-next");
      const btnPrev = this.element.querySelectorAll("#btn-prev");
      
      btnNext.forEach((btn) => {
        btn.addEventListener("click", () => {
          this.swiper.slideNext();
        });
      });
      
      btnPrev.forEach((btn) => {
        btn.addEventListener("click", () => {
          this.swiper.slidePrev();
        });
      });
    }
  }
}